import { useTranslation } from 'react-i18next'

import { currencyFields, inputCategories } from '../constants'
import { getInputCategory, isNonBlankValueField } from '../helpers'
import BooleanInput from './BooleanInput/BooleanInput'
import CurrencyInput from './CurrencyInput/CurrencyInput'
import DateRangeInput from './DateRangeInput/DateRangeInput'
import MultiValueInput from './MultiValueInput/MultiValueInput'
import NumericInput from './NumericInput/NumericInput'
import RangeInput from './RangeInput/RangeInput'
import RegionInput from './RegionInput/RegionInput'
import SingleValueInput from './SingleValueInput/SingleValueInput'

const ValueEditorRenderer = ({
  matchType,
  field,
  value,
  onChange,
  matchCase,
  onChangeMatchCase,
  disabled,
  showCombo,
  comboItems,
  hierarchical,
  hasError,
  inputBackgroundColor,
  matchCurrency,
  onChangeMatchCurrency,
  currencies,
  storeCurrencyCode,
  selectableCurrency,
}) => {
  const { t } = useTranslation()
  const category = getInputCategory(matchType, field)
  const rejectsBlankValues = isNonBlankValueField(field)

  if (category === inputCategories.singleValue) {
    return (
      <SingleValueInput
        value={value}
        onChange={onChange}
        matchCase={matchCase}
        onChangeMatchCase={onChangeMatchCase}
        disabled={disabled}
        showCombo={showCombo}
        comboItems={comboItems}
        hasError={hasError}
        rejectsBlankValues={rejectsBlankValues}
        inputBackgroundColor={inputBackgroundColor}
      />
    )
  }

  if (category === inputCategories.multiValue) {
    return (
      <MultiValueInput
        value={value}
        onChange={onChange}
        matchCase={matchCase}
        onChangeMatchCase={onChangeMatchCase}
        disabled={disabled}
        showCombo={showCombo}
        comboItems={comboItems}
        hierarchical={hierarchical}
        hasError={hasError}
        rejectsBlankValues={rejectsBlankValues}
        inputBackgroundColor={inputBackgroundColor}
      />
    )
  }

  if (category === inputCategories.numeric) {
    return (
      <NumericInput
        value={value}
        onChange={onChange}
        disabled={disabled}
        label={t('Valor')}
        hasError={hasError}
        inputBackgroundColor={inputBackgroundColor}
      />
    )
  }

  if (category === inputCategories.currency) {
    return (
      <CurrencyInput
        value={value}
        onChange={onChange}
        disabled={disabled}
        matchCurrency={matchCurrency}
        onChangeMatchCurrency={onChangeMatchCurrency}
        currencies={currencies}
        storeCurrencyCode={storeCurrencyCode}
        selectableCurrency={selectableCurrency}
        hasError={hasError}
        inputBackgroundColor={inputBackgroundColor}
      />
    )
  }

  if (category === inputCategories.range) {
    const isCurrencyField = field && currencyFields.includes(field)

    return (
      <RangeInput
        value={value}
        onChange={onChange}
        disabled={disabled}
        matchCurrency={matchCurrency}
        onChangeMatchCurrency={onChangeMatchCurrency}
        currencies={currencies}
        storeCurrencyCode={storeCurrencyCode}
        selectableCurrency={selectableCurrency && isCurrencyField}
        isCurrencyField={isCurrencyField}
        hasError={hasError}
        inputBackgroundColor={inputBackgroundColor}
      />
    )
  }

  if (category === inputCategories.daysElapsed) {
    return (
      <NumericInput
        value={value}
        onChange={onChange}
        disabled={disabled}
        label={t('Días')}
        hasError={hasError}
        inputBackgroundColor={inputBackgroundColor}
      />
    )
  }

  if (category === inputCategories.dateRange) {
    return <DateRangeInput value={value} onChange={onChange} disabled={disabled} />
  }

  if (category === inputCategories.region) {
    return (
      <RegionInput value={value} onChange={onChange} comboItems={comboItems} disabled={disabled} hasError={hasError} />
    )
  }

  if (category === inputCategories.boolean) {
    return <BooleanInput value={value} onChange={onChange} disabled={disabled} />
  }

  return null
}

export default ValueEditorRenderer
